import React, { Component } from "react";
import { connect } from "react-redux";
import { updatePassword } from "../../../../domain/auth/authActions";
import PasswordChangeForm from "../../../forms/secure/PasswordChangeForm";
import StatusMessage from "../../../presentational/StatusMessage";
import * as StatusMessages from "../../../../constants/StatusMessages";
import { FormattedMessage } from "react-intl";
import { Requirements } from "../../public/PasswordForgot";
import track from "react-tracking";
import { retrieveProfile } from "assets/scripts/domain/profile/profileActions";
class PasswordChange extends Component {
    /* --- React Lifecycle Methods --- */
    /**
     * React lifecycle method
     *
     * @method render
     * @private
     * @returns {HTMLElement} Component element
     */
    render() {
        return (<div className="wrapper">
				<div className="vr vr_x4">
					<h2 className="hdg js-pageHeader">
						<FormattedMessage id="passwordChange.header" defaultMessage="Change Password"/>
					</h2>
				</div>
				<StatusMessage isError={!this.props.authIsSuccess} isSuccess={this.props.authIsSuccess} isActive={this.props.authIsSuccess !== null ? true : false} customMessage={this.props.authIsSuccess ?
            StatusMessages.AUTH.SUCCESS_MESSAGE_PASSWORD_CHANGED :
            ""} domain="auth"/>
				<StatusMessage isError isActive={this.props.authError ? true : false} error={this.props.authError ? this.props.authError : null} customMessage={StatusMessages.AUTH.INTRO_PASSWORD_CHANGE} domain="auth"/>
				<div className="passwordContent">
					<div>
						<div className="vr vr_x5">
							<div className="text">
								<FormattedMessage tagName="p" id="passwordChange.intro" defaultMessage="You can change your password and security questions below."/>
							</div>
						</div>
						<div className="u-isVisuallyHidden">
							<FormattedMessage tagName="h2" id="passwordChange.requirements.header" defaultMessage="Password requirements:"/>
							<Requirements />
						</div>
						<div className="vr vr_x5">
							<PasswordChangeForm securityQuestions={this.props.securityQuestions} updatePassword={this.props.updatePassword} fieldErrors={this.props.authFieldErrors} isLoading={this.props.authIsLoading} locale={this.props.locale} email={this.props.email}/>
						</div>
					</div>
					<div aria-hidden="true" className="marginTop7em">
						<div className="vr vr_x2">
							<h2 className="label">
								<FormattedMessage id="passwordChange.requirements.header" defaultMessage="Password requirements:"/>
							</h2>
						</div>
						<div className="vr vr_x5">
							<div className="text">
								<Requirements className="listV listV_x3 mix-listV_bullet"/>
							</div>
						</div>
					</div>
				</div>
			</div>);
    }
}
/* --- React Redux bootstrapping --- */
const mapStateToProps = (state) => ({
    authError: state.auth.error,
    authFieldErrors: state.auth.fieldErrors,
    authIsLoading: state.auth.isLoading,
    authIsSuccess: state.auth.isSuccess,
    securityQuestions: state.auth.questions,
    locale: state.i18n.locale,
    email: state.profile.profile?.email
});
const bindActionsToProps = {
    updatePassword,
    retrieveProfile
};
/* Create and export container component that wraps PasswordChange for property binding */
export default track({ page: "PasswordChange" }, { dispatchOnMount: true })(connect(mapStateToProps, bindActionsToProps)(PasswordChange));



// WEBPACK FOOTER //
// ./src/assets/scripts/components/containers/secure/PasswordChange/PasswordChange.tsx